import {OnChanges, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CdkDragEnd} from '@angular/cdk/drag-drop';
import {DIMENSION_PRINT_2D_HEIGHT, DIMENSION_PRINT_2D_WIDTH} from './tools';

@Component({
  selector: 'dynamicPosition',
  template: `
    <div cdkDragBoundary=".dragBoundary" class="position-absolute pointer-event {{innerClass}}"
         cdkDrag
         #dragContainer
         [ngStyle]="{'z-index': zIndex}"
         [cdkDragFreeDragPosition]="_initialPosition"
         (cdkDragEnded)="dragEnd($event)">
      <ng-content></ng-content>
    </div>
  `,
  standalone: false
})
export class DynamicPositionComponent implements OnChanges {

  @Input() container: { width: number; height: number };
  @Input() position: string | { x: number; y: number };
  @Input() zIndex = 1;
  @Input() innerClass = '';

  @ViewChild('dragContainer') dragContainer: ElementRef;

  public _initialPosition = {x: 0, y: 0};

  @Output() positionChange = new EventEmitter();

  constructor(
    public el: ElementRef,
  ) {}

  ngOnChanges(): void {
    if (!this.container.width || !this.container.height) {
      return;
    }

    const _position = this.normalizePosition(this.position);
    this._initialPosition = this.printPositionToCanvas(_position);
  }

  normalizePosition(position: any): any {
    if (typeof position === 'string') {
      return position;
    }
    if (position.x !== undefined && position.y !== undefined) {
      return `${position.x},${position.y}`;
    }
    return '0,0';
  }

  printPositionToCanvas(dimension: string): any {
    const [elX, elY] = dimension.split(',').map(Number);
    return {
      x: elX / (DIMENSION_PRINT_2D_WIDTH / this.container.width),
      y: elY / (DIMENSION_PRINT_2D_HEIGHT / this.container.height)
    };
  }


  domToCanvasPosition(item): any {
    const [elX, elY] = this.getItemCanvasPosition(item);
    return {
      x: Math.round(elX * (DIMENSION_PRINT_2D_WIDTH / this.container.width)),
      y: Math.round(elY * (DIMENSION_PRINT_2D_HEIGHT / this.container.height))
    };
  }

  dragEnd(event: CdkDragEnd): void {
    const item = event.source.element.nativeElement;

    const computedPosition = this.domToCanvasPosition(item);

    this.positionChange.emit(computedPosition);
  }

  getItemCanvasPosition(nativeElement): any {
    const transform = nativeElement.style.transform;

    return transform.match(/[0-9]*px/gm).map(a => a.replace('px', ''));
  }
}
